export const PAYMENT_REQUIREMENTS_OUTGOING_MODULE_NAME: string = 'outgoing';

export enum PaymentRequirementsOutgoingAction {
	recallPayment = 'recallPayment',
	create = 'create',
}

export enum PaymentRequirementsOutgoingMutation {}

export enum PaymentRequirementsOutgoingGetter {}